import ReferrersReport from './ReferrersReport';

export default ReferrersReport;
